import { VendorLogo } from "./VendorLogo";

/**
 * Vendor identity used by the model tables and the landing preview —
 * renders the official mark when available, letter avatar otherwise.
 * Kept as a thin alias so call sites read consistently.
 */
export function VendorAvatar({ vendor, size = 32 }: { vendor: string; size?: number }) {
  return <VendorLogo vendor={vendor} size={size} />;
}
